<template>
    <div>
        <v-container fluid class="pa-6" >
            <v-alert color="info" text border="left">
                {{ $t('consentDurationExplanation') }}
            </v-alert>

            <v-row class="mb-2">
                <v-col cols="6" v-for="consentDuration in newConsentDuration" :key="consentDuration.id">
                    <v-card class="pa-2" >
                        <v-card-text class=" d-flex justify-space-between">
                            <div class="d-flex align-center">
                                <v-icon color="primary">${{ consentDuration.icon }} </v-icon>
                                <div class="ml-3">
                                    <b>{{ $t(consentDuration.label) }}</b>
                                    <p class="mb-0">{{ $t(consentDuration.subtitle) }}</p>
                                </div>
                            </div>
                            <div class="d-flex align-center">
                                <v-text-field @change="testValue(consentDuration.label, $event)" hide-details solo style="width: 70px;" class="input-form mr-2 flex-grow-0" flat v-model="consentDuration.duration" :label="$t('value')" type="number" min="0" />
                                {{ $t('months') }}
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
           
            <v-btn color="primary" depressed class="mr-2" @click="recordConsentsDuration">{{ $t('recordButton') }}</v-btn>
            <v-btn color="primary" depressed outlined @click="reinitConsentsDuration" v-if="consentsDurationsHasChanged">{{ $t('reinitConsentsDuration') }}</v-btn>
        </v-container>
    </div>
</template>

<script>
import GenericDataService from '@/services/GenericDataService'
export default {
    name: "ConsentDuration",
    components: {    },
    data() {
        return {
            consentsDurations: [],
            newConsentDuration: [],
        }
    },
    methods: {
        testValue(label, $evt){
            if($evt.includes('-') || $evt.includes('e')) {
                this.$set(this.newConsentDuration.find(e => e.label === label), 'duration', 0)
            }
        },
        recordConsentsDuration() {
            let payload = {};
            this.newConsentDuration.forEach(e => {
                payload[e.label] = parseInt(e.duration);
            });
            GenericDataService.postData('/optin/setConsentsDurations', payload).then((response) => {
                if(response.data.success) {
                    this.consentsDurations = this._.cloneDeep(this.newConsentDuration)
                    this.$store.dispatch('ADD_SNACK', {
                        message: this.$t('successActionConfirmed'),
                    })
                }
            })
        },
        reinitConsentsDuration() {
            this.newConsentDuration = this._.cloneDeep(this.consentsDurations)
        }
    },
    computed: {
        consentsDurationsHasChanged() {
        // Vérifie si au moins une durée a changé entre consentsDurations et newConsentDuration
        for (let i = 0; i < this.consentsDurations.length; i++) {
            if (
                this.consentsDurations[i].duration !== this.newConsentDuration[i].duration
            ) {
                return true;
            }
        }
        return false;
        }
    },
    created() {
        GenericDataService.getData('/optin/getConsentsDurations').then((response) => {
            this.consentsDurations = response.data.data
            this.newConsentDuration = this._.cloneDeep(response.data.data)
        })
    }
};
</script>
